import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Popover, Row, Spin, Table } from "antd";

// import salesManageApi from "../../../apis/SalesManage.api";
import moment from "moment";

import * as XLSX from "xlsx";

import reviewApi from "../../../apis/Review.api";
import ReviewExcel from "../../../files/리뷰엑셀업로드_양식.xlsx";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";

const ReviewExcelUpload = ({ setReviewModalShow, getReadReviews }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const [loadingStatus, setLoadingStatus] = useState(false);

  const [uploadExcelData, setUploadExcelData] = useState([]);
  const [uploadExcelName, setUploadExcelName] = useState("");
  const columns = [
    {
      title: "상품아이디",
      dataIndex: "상품아이디",
      key: "상품아이디",
      // ellipsis: true,
      align: "center",
    },
    {
      title: () => (
        <Row align={"middle"} justify={"center"} style={{ gap: 5 }}>
          리뷰상세내용
          <Popover
            title={`리뷰상세내용`}
            content={() => (
              <>
                <p style={{ margin: 0 }}>
                  개인별 주관적인 의견으로 오해의 소지가 있을 수 있는 상품의
                  기능 및 효과에 대한 단어는 '*'로 가려집니다.
                </p>
                <p style={{ margin: 0, color: "#868e96" }}>
                  ex. 효과 -> 효* / 탈모 -> 탈*
                </p>
              </>
            )}
            overlayStyle={{
              maxWidth: "200px",
            }}
            trigger={["hover", "click"]}
          >
            <img
              src={`/assets/images/warning.png`}
              alt={`warning-icon`}
              style={{
                width: "1em",
                height: "1em",
                cursor: "pointer",
              }}
            />
          </Popover>
        </Row>
      ),
      dataIndex: "리뷰상세내용",
      key: "리뷰상세내용",
      // align: "center",
      width: 150,
      render: (value) => (
        <span style={{ whiteSpace: "pre-line" }}>{value}</span>
      ),
    },
    {
      title: "구매자평점",
      dataIndex: "구매자평점",
      key: "구매자평점",
      align: "center",
      width: 60,
    },
    {
      title: "리뷰등록일",
      dataIndex: "리뷰등록일",
      key: "리뷰등록일",
      align: "center",
      render: (value) => {
        if (value) {
          return <>{moment(value)?.format("YYYY.MM.DD")}</>;
        } else return "-";
      },
    },
    {
      title: "베스트리뷰",
      dataIndex: "베스트리뷰",
      key: "베스트리뷰",
      align: "center",
      width: 60,
      render: (value) => {
        if (value) {
          return value;
        } else return "N";
      },
    },
  ];
  /**
   * 업로드된 엑셀 읽기
   * ExcelData, ExcelName 저장
   */
  const readExcelData = (e) => {
    setIsLoading(true);
    if (e.target.value !== "") {
      setLoadingStatus(true);
      let reader = new FileReader();
      reader.onload = () => {
        let fileData = reader.result;
        let wb = XLSX.read(fileData, {
          type: "binary",
          cellDates: true,
          dateNF: "YYYY-MM-DD",
        });
        let sheetNameList = wb.SheetNames;
        let firstSheet = wb.Sheets[sheetNameList[0]];

        let data = XLSX.utils.sheet_to_json(firstSheet, { raw: false });
        let list = [];
        for (let i = 0; i < data?.length; i++) {
          let param = {
            ...data[i],
            unique_id: i,
          };
          for (let j = 0; j < status.replaceReviewBodyList?.length; j++) {
            const replaceWord = status.replaceReviewBodyList[j];
            param = {
              ...param,
              리뷰상세내용: String(param["리뷰상세내용"]).replaceAll(
                replaceWord[0],
                replaceWord[1],
              ),
            };
          }
          list.push(param);
        }
        setUploadExcelData(list);
        setUploadExcelName(e.target.files[0]?.name);
      };
      reader.readAsBinaryString(e.target.files[0]);
      setLoadingStatus(false);
    } else {
      setUploadExcelData([]);
      setUploadExcelName("");
    }
    setIsLoading(false);
  };

  const excelKeyData = (value) => {
    switch (value) {
      case "product_id":
        return "'상품아이디'가";
      case "review_body":
        return "'리뷰상세내용'이";
      case "review_score":
        return "'구매자평점'이";
      case "created_at":
        return "'리뷰등록일'이";
      default:
        return "";
    }
  };

  /**
   * 엑셀 데이터 업로드
   */
  const handleExcelUpload = async () => {
    setIsLoading(true);
    let list = [];
    for (let i = 0; i < uploadExcelData?.length; i++) {
      const data = uploadExcelData[i];
      setLoadingStatus(true);
      let param = {
        product_id: data?.["상품아이디"] ?? null,
        review_body: data?.["리뷰상세내용"] ?? null,
        review_score: data?.["구매자평점"] ?? null,
        created_at: data?.["리뷰등록일"] ? moment(data?.["리뷰등록일"]) : null,
        is_best:
          data?.["베스트리뷰"] && data?.["베스트리뷰"] === "Y" ? true : false,
        unique_id: i,
      };
      for (const key in param) {
        if (param[key] === null) {
          alert(
            `${i + 1}행 ${excelKeyData(
              key,
            )} 없습니다. 작성 후 다시 업로드해주세요.`,
          );
          setIsLoading(false);
          setLoadingStatus(false);
          return;
        }
      }

      list.push(param);
    }
    const res = await reviewApi.addReviewListExcel({
      reviewList: list,
    });
    if (res.code === 200) {
      alert("정상적으로 등록이 완료 되었습니다.");
      getReadReviews();
      setReviewModalShow(false);
    } else {
      window.alert("오류가 발생했습니다. 관리자에게 문의하세요");
      console.log(res);
    }
    setIsLoading(false);
    setLoadingStatus(false);
    // setTimeout(() => {
    // }, 2000)
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.download = "리뷰엑셀업로드_양식";

    link.href = ReviewExcel;

    link.click();
  };
  return (
    <div className={`excel-body`}>
      {isLoading && loadingStatus && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            border: "solid 1px #ced4da",
            borderRadius: "5px",
            backgroundColor: "white",
            padding: "1em 1.5em",
            display: "flex",
            alignItems: "center",
            gap: "1em",
            boxShadow: "0 0px 6px 0 rgba(0, 0, 0, 0.16)",
            zIndex: 9,
          }}
        >
          <Spin style={{ lineHeight: 1 }} />
          <p style={{ margin: 0, whiteSpace: "pre-line" }}>
            문구를 수정하여 등록 중입니다{"\n"}
            <span
              style={{
                color: "#868e96",
              }}
            >
              * 절대 창을 닫지 마세요
            </span>
          </p>
        </div>
      )}
      <b>엑셀 파일을 업로드 하세요</b>
      <div className={`excel-file-upload-div`}>
        <div className={`excel-file-upload-each`}>
          <p className={`upload-title`}>파일 업로드</p>
        </div>
        <div className={`excel-file-upload-each`}>
          <div className={`upload-input`}>
            {uploadExcelName?.length ? uploadExcelName : "선택된 파일 없음"}
          </div>
          <Button
            className={`excel-file-select-btn`}
            onClick={() => {
              let excelInput = document.getElementById("excelFile");
              if (excelInput) {
                excelInput.click();
              }
            }}
            loading={isLoading}
          >
            파일 선택
          </Button>
          <Button
            className={`excel-file-upload-btn`}
            onClick={handleExcelUpload}
            loading={isLoading}
          >
            등록하기
          </Button>
        </div>
      </div>
      <input
        style={{ display: "none" }}
        // disabled={validation}
        type={"file"}
        id="excelFile"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        onChange={readExcelData}
      />
      <>
        <p className={`excel-description`}>
          * 스마트스토어에서 다운로드 받은 파일에 등록할 <b>상품아이디</b>를
          작성해 주세요.
        </p>
        {user?.id !== 4 && (
          <p className={`excel-description`}>
            * 필수정보(<b>상품아이디, 리뷰상세내용, 구매자평점, 리뷰등록일</b>
            )가 제대로 입력되었는지 확인해주세요.
          </p>
        )}
        <p className={`excel-description`}>
          * 파일 형식은 <b>XLSX</b>로 올려주세요.
        </p>
        <p className={`excel-description`}>
          * 리뷰가 기재된 엑셀파일 선택 후 <b>등록하기</b>를 눌러 리뷰등록을
          완료하세요.
        </p>
        {user?.id !== 4 &&
          user?.id !== 7 &&
          user?.id !== 8 &&
          user?.id !== 9 && (
            <Button
              className="excel-template-download"
              href={`${process.env.REACT_APP_HOST}/assets/files/리뷰엑셀업로드_양식.xlsx`}
              // onClick={handleDownload}
            >
              <p className={`excel-description`}>엑셀 양식 다운로드</p>
            </Button>
          )}
        <Table
          className={`commission-table`}
          columns={columns}
          dataSource={uploadExcelData}
          loading={isLoading}
          bordered
          size="small"
          rowKey="unique_id"
          rowClassName="coupon-table-row"
          pagination={false}
          scroll={{
            y: "25vh",
          }}
          style={{
            margin: "0.5em 0",
          }}
        />
      </>
    </div>
  );
};

export default ReviewExcelUpload;
